import React from "react";
import Text from "../Text";
import { Wrapper } from "../ImageCropModal/ModalCrop.style";
import FlexContainer from "../FlexContainer";
import CheckIcon from "src/img/new/green-check.svg";
import CloseIcon from "src/img/CloseButton@2x.png";

export const AssetList = (props) => {
    const {
        carouselAssets,
        setCarouselAssets,
        carouselCurrentAsset,
        setCarouselCurrentAsset,
        croppedAssets,
    } = props;
    const handleRemoveAsset = (indexToRemove) => {
        setCarouselAssets((prevAssets) => prevAssets.filter((_, index) => index !== indexToRemove));
    };
    return (
        <Wrapper marginTop="10px" style={{ position: "absolute", top: "520px", overflow: "" }}>
            <Text weight="bold" size="16px" align="left">
                Select Media to Edit
            </Text>

            <FlexContainer
                gap="9px"
                height="280px"
                style={{
                    overflow: "auto",
                    paddingTop: "10px",
                    paddingRight: "10px",
                    scrollbarWidth: "none",
                }}
            >
                {carouselAssets &&
                    carouselAssets.map((asset, index) => {
                        return (
                            <div style={{ position: "relative" }} key={index}>
                                <div
                                    style={{
                                        width: "222px",
                                        minHeight: "57px",
                                        border:
                                            index === carouselCurrentAsset.index
                                                ? "1px solid #36BE25"
                                                : "1px solid #DEE0E6",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyItems: "center",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        position: "relative",
                                        cursor: "pointer",
                                        pointerEvents: "none",
                                    }}
                                    onClick={() => setCarouselCurrentAsset(asset)}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyItems: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        {asset.type === "video" ? (
                                            <video
                                                style={{
                                                    height: "38px",
                                                    width: "67px",
                                                    opacity: 1,
                                                    borderRadius: "6px",
                                                    marginLeft: "10px",
                                                    objectFit: "cover",
                                                }}
                                            >
                                                <source src={asset.data} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        ) : (
                                            <img
                                                src={asset.data}
                                                alt="Asset Image"
                                                style={{
                                                    height: "38px",
                                                    width: "67px",
                                                    opacity: 1,
                                                    borderRadius: "6px",
                                                    marginLeft: "10px",
                                                }}
                                            />
                                        )}

                                        <div style={{ marginLeft: "15px" }}>{`Asset ${index + 1}`}</div>
                                    </div>
                                    {index === croppedAssets[index]?.index ? (
                                        <img
                                            src={CheckIcon}
                                            alt="check mark"
                                            style={{
                                                height: "15px",
                                                width: "15px",
                                                marginRight: "15px",
                                            }}
                                        />
                                    ) : null}

                                </div>
                                <img
                                    onClick={() => handleRemoveAsset(index)}
                                    src={CloseIcon}
                                    alt="close icon"
                                    style={{
                                        height: "18px",
                                        width: "18px",
                                        position: "absolute",
                                        top: "-5px",
                                        right: "-5px",
                                        cursor: "pointer",
                                        zIndex: 99,
                                        pointerEvents: index === croppedAssets[index]?.index ? "none" : "all",
                                    }}
                                />
                            </div>
                        );
                    })}
            </FlexContainer>
        </Wrapper>
    );
};
